"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ProteusError_1 = require("./ProteusError");
var DecodeError = (function (_super) {
    __extends(DecodeError, _super);
    function DecodeError(message, code) {
        if (message === void 0) { message = 'Unknown decoding error'; }
        if (code === void 0) { code = 3; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, DecodeError.prototype);
        return _this;
    }
    DecodeError.CODE = {
        CASE_300: 300,
        CASE_301: 301,
        CASE_302: 302,
        CASE_303: 303,
    };
    return DecodeError;
}(ProteusError_1.default));
var InvalidType = (function (_super) {
    __extends(InvalidType, _super);
    function InvalidType(message, code) {
        if (message === void 0) { message = 'Invalid type'; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, InvalidType.prototype);
        return _this;
    }
    return InvalidType;
}(DecodeError));
var InvalidArrayLen = (function (_super) {
    __extends(InvalidArrayLen, _super);
    function InvalidArrayLen(message, code) {
        if (message === void 0) { message = 'Invalid array length'; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, InvalidArrayLen.prototype);
        return _this;
    }
    return InvalidArrayLen;
}(DecodeError));
var LocalIdentityChanged = (function (_super) {
    __extends(LocalIdentityChanged, _super);
    function LocalIdentityChanged(message, code) {
        if (message === void 0) { message = 'Local identity changed'; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, LocalIdentityChanged.prototype);
        return _this;
    }
    return LocalIdentityChanged;
}(DecodeError));
Object.assign(DecodeError, {
    InvalidArrayLen: InvalidArrayLen,
    InvalidType: InvalidType,
    LocalIdentityChanged: LocalIdentityChanged,
});
exports.default = DecodeError;
//# sourceMappingURL=DecodeError.js.map


//////////////////
// WEBPACK FOOTER
// ../proteus/dist/errors/DecodeError.js
// module id = 41
// module chunks = 0 1